<template>
<div id="recuperaciones_ws" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-row align-center justify-center>
            <v-col sm="12" >
                <base-material-card color="primary" icon="library_books" title="Solicitud de Evidencias de Consulta Vucem" class="elevation-1 px-5 py-3" >

                    <br>
                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        <v-tab :key="'in-view'" >Generar Consulta</v-tab>
                        <v-tab :key="'in-report'" >Consultas Programadas</v-tab>

                        <v-tab-item :key="'in-view'" >

                            <v-row row wrap>
                                <v-col sm="12" >
                                    <v-card-text>
                                        <v-card-title>
                                            <span class="headline" ></span>
                                        </v-card-title>
                                        <v-form ref="form1" lazy-validation>
                                            <v-container grid-list-md text-xs-center>
                                                <v-row row wrap>
                                                    <v-col sm="12" >
                                                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Consulta" @change="clear_values()" :rules="[rules.required]" >
                                                        </v-autocomplete>
                                                    </v-col>
                                                </v-row>

                                                <v-row v-if="model.tipo_reporte == 1" row wrap>
                                                    <v-col cols="10" >
                                                        <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" :rules="[rules.required, validaPedimento]" ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="2" >
                                                        <v-btn icon title="Pegar Listado" @click="listado=''; dialog1 = !dialog1" v-tippy>
                                                            <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>

                                                <v-row v-if="model.tipo_reporte == 4" row wrap>
                                                    <v-col sm="12" >
                                                        Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                                                    </v-col>
                                                    <v-col sm="10" >
                                                        <v-combobox v-model="lista_filtrada" label="Lista de archivos" multiple persistent-hint small-chips disabled color="green" >
                                                        </v-combobox>
                                                    </v-col>
                                                    <v-col cols="2" >
                                                        <v-btn icon title="Pegar Listado" @click="dialogListado = !dialogListado" v-tippy>
                                                            <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>

                                                <v-row v-if="model.tipo_reporte == 3 || model.tipo_reporte == 2" row wrap>
                                                    <v-col>

                                                        <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                            <template v-slot:activator="{ on }" >
                                                                <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaFecha]" >
                                                                </v-text-field>
                                                            </template>

                                                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false" >
                                                                <v-spacer />

                                                                <v-btn color="secondary" x-small @click="menu3 = false" >
                                                                    Cancelar
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-menu>
                                                    </v-col>
                                                    <v-col>
                                                        <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                            <template v-slot:activator="{ on }" >
                                                                <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaFecha]" >
                                                                </v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu4 = false" >
                                                                <v-spacer />

                                                                <v-btn color="secondary" x-small @click="menu4 = false" >
                                                                    Cancelar
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-menu>

                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>
                                    <v-card-actions>

                                        <v-spacer></v-spacer>

                                        <v-btn rounded color="primary" @click="get_data_view(0)" :loading="loading" >
                                            <v-icon>search</v-icon>Buscar
                                        </v-btn>

                                    </v-card-actions>
                                </v-col>
                            </v-row>
                            <v-card-text>

                                <v-client-table ref="vuetable" :data="data_view.datos" :columns="data_view.columns" :options="data_view.options" class="elevation-2 pa-2 scroll-table" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                    </template>

                                    <template slot="actions_view" slot-scope="props" >

                                        <v-btn x-small fab dark color="green" v-if="getPermisoReenvio(props.row) && props.row.estatus!='PENDIENTE' && props.row.estatus!='EN COLA' && props.row.estatus!='PENDIENTE AA' " @click="agregar(props.row)" title="Agregar a la Lista" v-tippy>
                                            <v-icon>add</v-icon>
                                        </v-btn>

                                    </template>
                                </v-client-table>

                                <v-card color="#eff8ed" class="elevation-2 pa-2 scroll-table" >

                                    <h5>Registros Seleccionados</h5>

                                    <v-client-table ref="vuetable222" :data="data_view2.datos" :columns="data_view2.columns" :options="data_view2.options" class="pa-2 scroll-table" >
                                        <template slot="noResults" >
                                            <v-alert :value="true" icon="info" color="info" >No se ha agregado ningún elemento</v-alert>
                                        </template>

                                        <template slot="actions_view" slot-scope="props" >
                                            <v-btn x-small fab dark color="red" title="Quitar de la Lista" @click="quitar(props.row)" v-tippy>
                                                <v-icon>remove</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-client-table>
                                    <v-card-actions>

                                        <v-spacer></v-spacer>

                                        <v-btn v-if="data_view2.datos.length > 0" rounded color="success" @click="generar" :loading="loading" >
                                            <v-icon>done</v-icon>Enviar
                                        </v-btn>

                                    </v-card-actions>
                                </v-card>
                            </v-card-text>
                        </v-tab-item>
                        <v-tab-item :key="'in-report'" >

                            <v-card-text>
                                <v-refresh-button :funcion="cargar" />

                                <v-client-table ref="principalTable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                    </template>

                                    <template slot="detail" slot-scope="props" >
                                        <v-btn icon color="primary" title="Mostrar Archivos" @click="showDetail(props.row)" >
                                            <v-icon v-if="registro_seleccionado != props.row.id" >add_circle</v-icon>
                                            <v-icon v-if="registro_seleccionado == props.row.id" >remove_circle</v-icon>
                                        </v-btn>
                                    </template>
                                    <template slot="actions" slot-scope="props" >

                                        <v-btn fab dark x-small color="red" title="Eliminar" @click="eliminar(props.row.id)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                        <v-btn fab dark x-small color="success" v-if="props.row.estatus=='Procesado'" title="Descargar Evidencias" @click="descargar(props.row)" v-tippy>
                                                        <v-icon dark>get_app</v-icon>
                                                    </v-btn>
                                    </template>

                                    <template slot="child_row" >
                                        <v-toolbar dense height="35pt" >
                                            <v-toolbar-title><span style="font-size:12pt" >Archivos:</span></v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text>
                                            <div class="row" >
                                                <v-spacer></v-spacer>
                                                <div class="col-xs-1" >
                                                    

                                                </div>
                                            </div>
                                            <div class="row" >
                                                <div class="col-xs-10" ></div>
                                            </div>
                                            <v-client-table ref="detailtable" :data="dias.items" :columns="columnsDias" :options="optionsDias" class="elevation-2 pa-2" >
                                                <template slot="noResults" >
                                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                                </template>

                                            </v-client-table>
                                        </v-card-text>
                                        <hr>

                                    </template>
                                </v-client-table>
                            </v-card-text>
                        </v-tab-item>

                    </v-tabs>

                </base-material-card>
            </v-col>
        </v-row>
    </v-container>
    <v-dialog v-model="dialog1" max-width="500px" >
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de pedimentos</h5>
                <span>Uno por línea</span>
                <v-form ref="formListado" lazy-validation="" >
                    <v-textarea outlined rows="15" v-model="listado" :rules="[validaListadoPreview]" ></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="listado=''; dialog1 = false" >Cancelar</v-btn>
                <v-btn small color="primary" @click="generaReporteListado('preview');" >Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" max-width="500px" >
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de pedimentos</h5>
                <span>Uno por línea</span>
                <v-form ref="formListado" lazy-validation="" >
                    <v-textarea outlined rows="15" v-model="listado" :rules="[validaListado]" ></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="listado=''; dialog2 = false" >Cancelar</v-btn>
                <v-btn small color="primary" @click="generaReporteListado('completo');" >Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modalErroresRecuperacion" min-width="50%" max-width="70%" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modalErroresRecuperacion = false" class="white--text" >cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Errores de Recuperación Webservice</strong>
                    </span>
                </v-card>
            </v-card-title>
            <v-card-text>
                <h5>Intentos de Recuperación: {{intentosRecuperacion}} </h5>
                <span>{{ mensajeErrores }}</span>

                <v-client-table ref="vuetableErroresRecuperacion" :data="errores" :columns="errores_columns" :options="errores_options" class="elevation-2 pa-2 scroll-table" >
                    <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                    </template>
                </v-client-table>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="modalErroresRecuperacion = false" >Cerrar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogListado" max-width="500px" >
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de documentos</h5>
                <span>Uno por línea</span>
                <v-form ref="formListado" lazy-validation="" >
                    <v-textarea outlined rows="15" v-model="model.archivo" :rules="[rules.required, maxListaRule]" ></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="model.archivo='';dialogListado = false" >Cancelar</v-btn>
                <v-btn small color="primary" @click="setListValues();" >Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="modal_acuses" max-width="500px" >
        <v-card>
            <v-card-text>
                <h5>Ingrese una lista de Coves para generarse desde Acuse</h5>
                <span>Uno por línea</span>
                <v-form ref="form_acuses" lazy-validation="" >
                    <br>
                    <v-autocomplete v-model="emisor_seleccionado" :items="emisores" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Emisor/Destinatario" :rules="[rules.required]" ></v-autocomplete>
                    <v-textarea outlined rows="15" v-model="acuses" :rules="[rules.required, maxListaRuleAcuses]" ></v-textarea>
                </v-form>
                <small style="color:red;" >*Este proceso no garantiza la generación, para ver el error en especifico debera enviar uno por uno</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="acuses=[];emisor_seleccionado='';modal_acuses = false" >Cancelar</v-btn>
                <v-btn small color="primary" @click="setListValuesAcuses();" >Enviar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
    created: function () {
        this.URL = this.$hostname;
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model.rfc = this.$local_storage.get("rfc");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
            this.permisoEliminar = true;
        this.cargarErrores();

    },
    data: () => ({

        to_download: [],
        emisores: [],
        norecuperados: true,
        emisor_seleccionado: "",
        allChecked: false,
        permisoEliminar: false,
        tab: null,
        lista_filtrada: [],
        lista_filtrada_acuses: [],
        errores_ws: [],
        errores: [],
        errores_columns: ["fecha", "error"],
        errores_options: {
            filterable: ["fecha", "error"],
            sortable: ["fecha", "error"],
        },
        modalErroresRecuperacion: false,
        intentosRecuperacion: 0,
        mensajeErrores: '',
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "E-Drive",
                disabled: true,
                to: ""
            },
            {
                text: "Recuperaciones de Documentos Importador Exportador",
                disabled: true,
                to: ""
            }
        ],
        tipos: [{
                "id": 1,
                "text": "Por Pedimento | Listado de Pedimentos"
            },
            /* Lourdes solicitó ocultarlo, ya que confunde a los clientes
            {
              "id": 2,
              "text": "Por Fechas de Actualización de Archivos"
            },*/
            {
                "id": 3,
                "text": "Por Fechas de Pedimento"
            }, {
                "id": 4,
                "text": "Por Lista de Documentos (Pedimento | Cove | eDocument)"
            }
        ],
        dias: {
            items: [],
            camposexcel: {
                "Pedimento": "no_pedimento",
                "Archivo": "archivo",
                "Tipo": "tipo",
                "Fecha Actualización": "fecha",
                "Estatus": "estatus",
                "Error": "error"

            },
        },
        columnsDias: [

            "no_pedimento",
            "archivo",
            "tipo",
            "fecha",
            "estatus",
            "error"
        ],
        optionsDias: {
            filterable: [
                "no_pedimento",
                "archivo",
                "tipo",
                "fecha",
                "error",
            ],
            sortable: [
                "no_pedimento",
                "archivo",
                "tipo",
                "fecha",
                "error",
            ],
            orderBy: {
                column: 'fecha',
                ascending: false
            },
            headings: {
                "no_pedimento": "Pedimento",
                "archivo": "Archivo",
                "tipo": "Tipo",
                "fecha": "Fecha",
                "estatus": "Estatus",
                "error": "Error"
            },
        },
        tipo_archivos: [{
            'id': 1,
            'text': 'Pedimentos'
        }, {
            'id': 4,
            'text': 'Estado de Pedimentos'
        }, {
            'id': 6,
            'text': 'Partidas'
        }, {
            'id': 7,
            'text': 'Coves'
        }, {
            'id': 10,
            'text': 'Acuses de Cove'
        }, {
            'id': 11,
            'text': 'eDocuments'
        }, {
            'id': 14,
            'text': 'Acuses de eDocuments'
        }, {
            'id': 15,
            'text': 'Remesas'
        }, {
            'id': 18,
            'text': 'Acuse de Remesas'
        }],
        dialog1: false,
        dialog2: false,
        modal_recuperacion: false,
        modal_acuses: false,
        modal_emisores: false,
        dialogListado: false,
        listado: "",
        datos: [],
        columns: ["detail", "fecha", "total", "recuperados", "procesados", "pendientes", "avance", "estatus", "actions"],
        options: {
            filterable: ["fecha", "estatus", ],
            sortable: ["fecha", "estatus", ],
            orderBy: {
                column: 'id',
                ascending: false
            },
            headings: {
                detail: '',
                fecha: "Solicitado",
                estatus: "Estatus",
                total: "Total Archivos",
                recuperados: "Recuperados",
                procesados: "Procesados",
                pendientes: "Pendientes",
                avance: "% Avance",
                actions: "Operaciones"
            },
            uniqueKey: "id",
        },
        loading: true,
        show_loading: true,
        acuses: [],
        model: {
            rfc: "",
            usuario: "",
            pedimento: "",
            fecha_de: "",
            fecha_a: "",
            reporte_url: "/reportes_vucem/recuperaciones_ws/",
            nombre_reporte: "Recuperaciones WS",
            tipo: "Recuperaciones WS",
            tipo_reporte: "",
            norecuperados: 0,
            archivo: "", //para buscar por nombre de archivo (pedimento|cove|edocument)
        },
        model_recuperacion: {
            rfc: '',
            fecha_de: '',
            fecha_a: '',
            archivos: '',
        },
        model_acuses: {
            id_documento: "",
            edocument: "",
            emisor: "",
        },
        registro_seleccionado: "",
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        menu5: false,
        menu6: false,
        rules: {
            required: v => !!v || "Este campo es requerido",
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        },
        data_view2: {
            datos: [],
            columns: ['actions_view', 'no_pedimento', 'clave_documento', 'tipo_operacion', 'tipo_pedimento', 'fecha_pedimento',
                'tipo', 'archivo', 'estatus', 'error', //'ext', 'estado', 'subestado',
                'fecha_actualizacion'
            ],
            options: {
                orderBy: {
                    column: 'no_pedimento',
                    ascending: true
                },
                filterable: [],
                sortable: [],
                headings: {
                    id_pedimento: '',
                    no_pedimento: 'No. Pedimento',
                    'clave_documento': "Clave Documento",
                    'tipo_operacion': "Tipo Operación",
                    'tipo_pedimento': "Tipo Pedimento",
                    fecha_pedimento: 'Fecha Pedimento',
                    // fecha_estado:'Fecha Estado',
                    //  estado:'Estado',
                    //  subestado:'Subestado',
                    tipo: 'Tipo',
                    archivo: 'Archivo',
                    //  ext:'Extensión',
                    estatus: 'Estatus',
                    error: 'Error',
                    fecha_actualizacion: 'Fecha Actualización',
                    actions_view: ''
                }
            }
        },
        data_view: {
            datos: [],
            columns: ['actions_view', 'no_pedimento', 'clave_documento', 'tipo_operacion', 'tipo_pedimento', 'fecha_pedimento',
                'tipo', 'archivo', 'estatus', 'error', //'ext', 'estado', 'subestado',
                'fecha_actualizacion'
            ],
            options: {
                orderBy: {
                    column: 'no_pedimento',
                    ascending: true
                },
                filterable: ['no_pedimento', 'clave_documento', 'tipo_operacion', 'tipo_pedimento', 'fecha_pedimento',
                    'tipo', 'archivo', 'estatus', 'error', // 'ext', 'estado', 'subestado',
                    'fecha_actualizacion'
                ],
                sortable: ['no_pedimento', 'clave_documento', 'tipo_operacion', 'tipo_pedimento', 'fecha_pedimento',
                    'tipo', 'archivo', 'estatus', 'error', //'ext', 'estado', 'subestado',
                    'fecha_actualizacion'
                ],

                headings: {
                    id_pedimento: '',
                    no_pedimento: 'No. Pedimento',
                    'clave_documento': "Clave Documento",
                    'tipo_operacion': "Tipo Operación",
                    'tipo_pedimento': "Tipo Pedimento",
                    fecha_pedimento: 'Fecha Pedimento',
                    // fecha_estado:'Fecha Estado',
                    //  estado:'Estado',
                    //  subestado:'Subestado',
                    tipo: 'Tipo',
                    archivo: 'Archivo',
                    //  ext:'Extensión',
                    estatus: 'Estatus',
                    error: 'Error',
                    fecha_actualizacion: 'Fecha Actualización',
                    actions_view: ''
                }
            }
        }
    }),
    computed: {

        superusuario() {
            return this.$local_storage.get("tipo_usuario") == "Super Usuario";
        },

    },
    methods: {
        getPermisoReenvio: function (row) {
            //Usuarios tipo Cliente y Grupo solo pueden reenviar Partidas, Coves, EDocuments y Remesas
            //Super Usuario y Soporte, pueden reenviar cualquiera
            const tipos = ["XML PARTIDA", "XML COVE", "PDF COVE", "PDF ACUSE COVE", "XML EDOCUMENT",
                "PDF EDOCUMENT", "PDF ACUSE EDOCUMENT", "XML REMESA", "PDF REMESA", "PDF ACUSE REMESA"
            ];
            const clientes = tipos.find(e => e == row.tipo);
            var tipo_usuario = this.$local_storage.get("tipo_usuario");

            if (row.estatus != "PENDIENTE" && row.estatus != "EN COLA" && row.estatus != 'PENDIENTE AA') {
                if (clientes != undefined && (tipo_usuario == "Cliente" || tipo_usuario == "Grupo")) {
                    return true;
                } else if (tipo_usuario == "Super Usuario" || tipo_usuario == "Soporte") {
                    return true;
                }
            }
            return false;
        },
        eliminar: function (idreporte) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el Proceso ?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var datos = {
                        id: idreporte,
                    }
                    axios.post(this.$hostname + 'vucem/delete_solicitud_evidencias/', datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El proceso se eliminó correctamente",
                                footer: ""
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el proceso. Favor de comunicarse con soporte.",
                                footer: '',
                            });
                            console.log(error);
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargar();
                        });
                }
            });
        },
        agregar(row) {
            if (this.data_view2.datos.length < 5) {
                this.data_view2.datos.push(row);
                let result = this.data_view.datos.filter(r => r.id_pedimento != row.id_pedimento && r.archivo != row.archivo);
                this.data_view.datos = result;

            } else {

                this.$swal({
                    type: "error",
                    title: "Operación no Permitida",
                    text: "Solo puede agregar un maximo de 5 elementos a la lista de peticiones.",
                    footer: ""
                });
            }

        },
        showDetail: function (row) {
            if (this.registro_seleccionado != row.id) {
                this.registro_seleccionado = row.id;
                this.cargarDias();
                var detallesAbiertos = this.$refs.principalTable.openChildRows;
                for (var k in detallesAbiertos) { //Cerramos detalles abiertos
                    if (detallesAbiertos[k] != row.id)
                        this.$refs.principalTable.toggleChildRow(detallesAbiertos[k]);
                }
            } else { //Significa que dio clic en '-' solo cerramos el detalle y no hacemos nada
                this.registro_seleccionado = '';
            }
            this.$refs.principalTable.toggleChildRow(row.id); //Mostramos detalle seleccionado

        },
        cargarDias: function () {
            let self = this;
            let encontrada = self.datos.find(e => e.id == self.registro_seleccionado);
            this.dias.items = encontrada.archivos;
            for (var k in this.dias.items) {
                this.dias.items[k].fecha = this.parseDate(this.dias.items[k].fecha);
                this.dias.items[k].estatus = this.getEstatusDetalle(this.dias.items[k].estatus);
                this.dias.items[k].tipo = this.getNombreTipo(this.dias.items[k].tipo);
                this.dias.items[k].error = this.getErrorWS(this.dias.items[k].error);

            }

        },
        getNombreTipo: function (id) {

            if (id == 1)
                return "XML PEDIMENTO";
            if (id == 4)
                return "XML ESTADO PEDIMENTO";
            if (id == 6)
                return "XML PARTIDA";
            if (id == 7)
                return "XML COVE";
            if (id == 10)
                return "PDF ACUSE COVE";
            if (id == 11)
                return "XML EDOCUMENT";
            if (id == 14)
                return "PDF ACUSE EDOCUMENT";
            if (id == 15)
                return "XML REMESA";
            if (id == 18)
                return "PDF ACUSE REMESA";

            return id;
        },
        quitar(row) {
            this.data_view.datos.push(row);
            let result = this.data_view2.datos.filter(r => r.id_pedimento != row.id_pedimento && r.archivo != row.archivo);
            this.data_view2.datos = result;
        },
        maxListaRule: function () {
            if (this.model.archivo == '' || this.model.archivo == undefined || Array.isArray(this.model.archivo)) {
                return "Lista vacia";
            }

            let x = this.model.archivo.split("\n");

            if (x.length > 250) {
                return "No se puede consultar mas de 250 pedimentos";
            }

            return true;
        },
        maxListaRuleAcuses: function () {
            if (this.acuses == '' || this.acuses == undefined || Array.isArray(this.acuses)) {
                return "Lista vacia";
            }

            let x = this.acuses.split("\n");

            if (x.length > 50) {
                return "No se puede consultar mas de 50 pedimentos";
            }

            return true;
        },
        setListValues: function () {
            this.lista_filtrada = [];
            let to_list = this.get_array_lista(this.model.archivo);
            for (var i = 0; i < to_list.length; i++) {
                if (this.lista_filtrada.includes(to_list[i])) {
                    continue;
                } else {
                    this.lista_filtrada.push(to_list[i]);
                }
            }
            this.dialogListado = !this.dialogListado;
        },
        setListValuesAcuses: function () {
            if (!this.$refs.form_acuses.validate()) {
                return false;
            }
            this.lista_filtrada_acuses = [];
            let to_list = this.get_array_lista(this.acuses);
            for (var i = 0; i < to_list.length; i++) {
                if (this.lista_filtrada_acuses.includes(to_list[i])) {
                    continue;
                } else {
                    this.lista_filtrada_acuses.push(to_list[i]);
                }
            }

            var data = {
                rfc: this.model.rfc,
                coves: this.lista_filtrada_acuses,
                emisor_destinatario: this.emisor_seleccionado
            }
            axios.post(this.$hostname + "vucem/encolar_coves_por_acuse/", data)
                .then(res => {
                    console.log(res);
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "Los Coves se enviarón a generar, este proceso puede tardar de 1 a 6 horas en completarse",
                        footer: ""
                    });
                })
                .catch(err => {
                    let mensaje;
                    if (typeof err.response !== "undefined") {
                        mensaje = err.response.data.mensaje;
                    } else {
                        mensaje = "Ocurrió un error al generar la vista previa";
                    }
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: mensaje,
                        footer: ""
                    });
                }).then(() => {
                    this.modal_acuses = [];
                    this.lista_filtrada_acuses = [];
                    this.modal_acuses = !this.modal_acuses;
                });
        },
        get_array_lista: function (cadena) {
            let data = cadena.split("\n");
            let newarr = data.filter(a => a.trim() !== '');
            for (var i = 0; i < newarr.length; i++) {
                newarr[i] = newarr[i].trim();
                newarr[i] = newarr[i].replace(',', '');
                newarr[i] = newarr[i].replace('.', '');
            }

            return newarr;
        },
        validaArchivo: function () {
            if (this.model.archivo != "" && !Array.isArray(this.model.archivo)) {
                this.model.archivo = this.model.archivo.trim();
                if (this.model.archivo.toString().length < 4) {
                    return "Nombre Documento no debe tener menos de 4 caracteres";
                }
            }
            return true;
        },
        validaPedimento: function () {
            if (this.model.pedimento != "") {
                if (!this.validarPatronPedimento(this.model.pedimento))
                    return "Pedimento no válido. Ejemplo: 240-0123-0000123";
            }
            return true;
        },
        validarPatronPedimento(pedimento) {
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },
        validaListado: function () {
            var listadoSinEspacios = this.removerLineasVacias(this.listado);
            if (listadoSinEspacios.length == 0) {
                return "Ingrese al menos 1 pedimento. Favor de verificar.";
            } else if (listadoSinEspacios.length > 250) {
                return "No se puede consultar mas de 250 pedimentos";
            } else {
                for (var k in listadoSinEspacios) {
                    if (!this.validarPatronPedimento(listadoSinEspacios[k]))
                        return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
                }
            }

            return true;
        },
        validaListadoPreview: function () {
            var listadoSinEspacios = this.removerLineasVacias(this.listado);
            if (listadoSinEspacios.length == 0) {
                return "Ingrese al menos 1 pedimento. Favor de verificar.";
            } else if (listadoSinEspacios.length > 250) {
                return "No se puede consultar mas de 250 pedimentos en Vista Previa";
            } else {
                for (var k in listadoSinEspacios) {
                    if (!this.validarPatronPedimento(listadoSinEspacios[k]))
                        return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
                }
            }

            return true;
        },
        removerLineasVacias(listado) {
            var listadoSplit = this.listado.split("\n");
            var listadoSinEspacios = listadoSplit.filter(item => {
                return item.trim() != "";
            });
            return listadoSinEspacios;
        },

        validaFecha: function (fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida."
            else
                return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."
            }
            return true;
        },
        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."
                if (Math.abs(diferencia) > 31)
                    return "Periodo máximo de consulta 31 dias. Favor de verificar."
            }
            return true;
        },
        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
            };
            axios.post(this.URL + "vucem/list_solicitudes_evidencias/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud)
                        });
                        this.datos = res.data;

                        for (var k in this.datos) {

                            this.datos[k].fecha = this.parseDate(this.datos[k].fecha);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            let archivos = this.datos[k].archivos;
                            this.datos[k].total = archivos.length;
                            this.datos[k].procesados = archivos.filter(e => e.estatus == 2).length + archivos.filter(e => e.estatus == 3).length;
                            this.datos[k].recuperados = archivos.filter(e => e.estatus == 4).length;
                            this.datos[k].pendientes = this.datos[k].total - this.datos[k].recuperados - this.datos[k].procesados  ;
                            this.datos[k].avance = "% " + parseInt((this.datos[k].recuperados + this.datos[k].procesados ) / this.datos[k].total * 100);

                        }

                    }
                })
                .catch(err => {

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getEstatus: function (estatus) {
            var arr_estatus = ["Pendiente", "Procesado", "Procesado"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return estatus;
        },
        getEstatusDetalle: function (estatus) {
            var arr_estatus = ["Pendiente", "Pendiente", "Procesado", "Error", "Recuperado"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return estatus;
        },
        getCriterioPredeterminados: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    if (params.tipo_reporte == 1) {
                        if (params.lista != undefined && params.lista.length > 0) {
                            return "Buscado por lista de pedimentos: " + params.lista.length;
                        } else if (params.pedimento != undefined)
                            return "Pedimento: " + params.pedimento;
                        else
                            return "Buscado por lista de pedimentos";
                    } else if (params.tipo_reporte == 4) {
                        return "Por lista de Documento";
                    } else {
                        return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    }
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }

        },
        get_data_view: function (opcion = 0) {
            if (!this.$refs.form1.validate() && opcion == 0) { //Opción sirve para saltar la validación cuando se busca por listado
                //Alguna operación o mensaje
            } else {
                if (this.model.tipo_reporte == 4 && this.model.archivo == '') {
                    this.$swal({
                        type: "info",
                        title: "Información",
                        text: "Debes ingresar al menos un elemento a la lista",
                        footer: ""
                    });

                    return false;
                }

                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = this.model;
                data["lista"] = this.removerLineasVacias(this.listado);
                if (data.pedimento == '') delete(data['pedimento']);
                if (data.fecha_de == '') delete(data['fecha_de']);
                if (data.fecha_a == '') delete(data['fecha_a']);
                if (data.archivo == '') delete(data['archivo']);
                if (data.tipo_reporte == 4) {
                    data['lista'] = this.get_array_lista(data['archivo']);
                    delete(data['archivo']);
                }

                axios({
                        method: "post",
                        url: this.$hostname + "reportes_vucem/recuperaciones_ws_preview/",
                        data: data
                    })
                    .then(response => {
                        this.to_download = [];
                        this.data_view.datos = response.data.filter(r => (r.estatus != 'PENDIENTE' && r.estatus != 'EN COLA' && r.estatus != 'PENDIENTE AA' && r.estatus != 'RECUPERADO') && r.ext == 'xml');

                        for (var k in this.data_view.datos) {
                            this.data_view.datos[k].error = this.getErrorWS(this.data_view.datos[k].error);
                        }

                    })
                    .catch(error => {
                        let mensaje;
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                        } else {
                            mensaje = "Reporte demasiado grande para vista previa. Intenta con un periodo más corto";
                        }

                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: ""
                        });
                    }).then(() => {
                        this.listado = "";
                        this.model.archivo = '';
                        this.lista_filtrada = [];
                        this.model.lista = '';
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        getTipo: function (nombre) {
            let tipo = "";

            if (nombre == "XML PEDIMENTO") {
                tipo = 1;
            };
            if (nombre == "XML ESTADO PEDIMENTO") {
                tipo = 4;
            };
            if (nombre == "XML PARTIDA") {
                tipo = 6;
            };
            if (nombre == "XML COVE") {
                tipo = 7;
            };
            if (nombre == "PDF ACUSE COVE") {
                tipo = 10;
            };
            if (nombre == "XML EDOCUMENT") {
                tipo = 11;
            };
            if (nombre == "PDF ACUSE EDOCUMENT") {
                tipo = 14;
            };
            if (nombre == "XML REMESA") {
                tipo = 15;
            };
            if (nombre == "PDF ACUSE REMESA") {
                tipo = 18;
            };

            return tipo;
        },
        generar: function () {

            let self = this;
            let archivos = [];

            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            this.data_view2.datos.forEach(function (r) {
                archivos.push({
                    "id_pedimento": r.id_pedimento,
                    "no_pedimento": r.no_pedimento,
                    "archivo": r.archivo,
                    "tipo": self.getTipo(r.tipo),
                    "estatus": 0
                });
            });
            let data = {
                rfc: this.$local_storage.get("rfc"),
                archivos: archivos,
                id_usuario: this.$local_storage.get("id_usuario")
            };

            axios({
                    method: "post",
                    url: this.$hostname + "vucem/solicitud_evidencias/",
                    data: data
                })
                .then(response => {
                    if (response.data === true) {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "Se han programado los documentos para su recuperación",
                            footer: ""
                        });
                        this.data_view2.datos = [];
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: response.data.Mensaje,
                            footer: ""
                        });
                    }
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error",
                        footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        generaReporteListado(tipoReporte) {
            if (this.$refs.formListado.validate()) {
                if (tipoReporte == "completo") {
                    this.generar_reporte_sqs(1);
                } else {
                    this.get_data_view(1);
                }
                this.dialog1 = false;
                this.dialog2 = false;
            }
        },
        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        clear_values() {
            this.model.pedimento = '';
            this.model.fecha_de = '';
            this.model.fecha_a = '';
            this.model.archivo = '';
            this.listado = "";
        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
       
        mostrarErroresRecuperacion: function (row) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id_pedimento: row.id_pedimento,
                tipo: row.tipo_validacion,
                filename: row.archivo
            }
            axios.post(this.$hostname + 'reportes_vucem/recuperaciones_ws_errores/', datos)
                .then((res) => {
                    this.errores = res.data;

                    for (var k in this.errores) {
                        this.errores[k].fecha = this.parseDate(this.errores[k].fecha);
                        this.errores[k].error = this.getErrorWS(this.errores[k].error);
                    }
                    var countErrores = this.errores.length;
                    this.intentosRecuperacion = countErrores;
                    if (row.estatus == "NO RECUPERABLE" || row.estatus == "RECUPERADO" || row.estatus == "TOKEN INCORRECTO" || row.estatus == "EDOCUMENT PROGRAMADO")
                        this.intentosRecuperacion += 1;
                    this.mensajeErrores = "Se encontraron " + countErrores + " errores de recuperación para el archivo '" + row.archivo + "' que es un " + row.tipo;
                    this.modalErroresRecuperacion = true;

                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener errores de recuperación. Favor de comunicarse con soporte.",
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
     
        cargarErrores: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios.get(this.$hostname + "catalogos/errores_ws/")
                .then(res => {
                    this.errores_ws = res.data;
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de errores webservice.",
                        footer: ""
                    });
                }).then(() => {
                    this.cargar();
                });
        },
        getErrorWS: function (errorWs) {
            if (errorWs != null && errorWs.toString().trim() != "") {
                var filter = this.errores_ws.filter(function (e) {
                    return e.error.toString().trim().toLowerCase() == errorWs.toString().trim().toLowerCase();
                });
                if (filter.length > 0) {
                    return filter[0].metadato;
                } else
                    return errorWs;
            } else
                return errorWs;

        },
         descargar: function (row) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let key = row.rfc + "/evidencias/peticion_" + row.id + "/";
            
            var datos = {
                key: key,
                usuario: this.$local_storage.get("id_usuario"),
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_zip/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        this.$swal({
                            type: "info",
                            title: "Generado...",
                            text: "En breve recibirás una notificación para descargar el ZIP",
                            footer: '',
                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

    },
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: xx-small !important;
}
</style>
